module.exports = __webpack_public_path__ + "static/media/simple_flow.be814418.png";